export default __webpack_public_path__ + "static/media/edit.247a50c2.png";